import { JobOpeningIcon } from "../assets/svg/JobOpening";
import { DescriptionIcon } from "../assets/svg/DescriptionIcon";

export const offerStatusOptions = [
  { value: 'draft', label: 'Draft', color: 'gray' },
  { value: 'pending_approval', label: 'Pending Approval', color: 'yellow' },
  { value: 'approved', label: 'Approved', color: 'blue' },
  { value: 'sent', label: 'Sent', color: 'purple' },
  { value: 'viewed', label: 'Viewed', color: 'cyan' },
  { value: 'accepted', label: 'Accepted', color: 'green' },
  { value: 'declined', label: 'Declined', color: 'red' },
  { value: 'expired', label: 'Expired', color: 'orange' },
  { value: 'revoked', label: 'Revoked', color: 'gray' }
];

export const templateCategoryOptions = [
  { value: 'standard', label: 'Standard' },
  { value: 'executive', label: 'Executive' },
  { value: 'internship', label: 'Internship' },
  { value: 'contract', label: 'Contract' },
  { value: 'remote', label: 'Remote' }, 
  { value: 'custom', label: 'Custom' }
];

export const salaryFrequencyOptions = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'annually', label: 'Annually' }
];

export const currencyOptions = [
  { value: 'INR', label: '₹ INR' },
  { value: 'USD', label: '$ USD' },
  { value: 'EUR', label: '€ EUR' }
];

export const defaultSalaryComponents = [
  { component: 'Basic Salary', percentage: 40 },
  { component: 'House Rent Allowance (HRA)', percentage: 30 },
  { component: 'Special Allowance', percentage: 15 },
  { component: 'Performance Bonus', percentage: 10 },
  { component: 'Other Allowances', percentage: 5 }
];

export const defaultPlaceholders = [
  { key: '{{CANDIDATE_NAME}}', label: 'Candidate Name', description: 'Full name of the candidate', required: true },
  { key: '{{JOB_TITLE}}', label: 'Job Title', description: 'Position being offered', required: true },
  { key: '{{DEPARTMENT}}', label: 'Department', description: 'Department name', required: false },
  { key: '{{SALARY}}', label: 'Salary', description: 'Annual salary amount', required: true },
  { key: '{{JOINING_DATE}}', label: 'Joining Date', description: 'Expected date of joining', required: true },
  { key: '{{MANAGER_NAME}}', label: 'Manager Name', description: 'Reporting manager name', required: false },
  { key: '{{WORK_LOCATION}}', label: 'Work Location', description: 'Office location', required: false },
  { key: '{{OFFER_EXPIRY_DATE}}', label: 'Offer Expiry', description: 'Date until offer is valid', required: true }
];

export const defaultTemplateContent = `
<div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
  <div style="text-align: center; margin-bottom: 30px;">
    <h1>{{COMPANY_NAME}}</h1>
    <p>Offer Letter</p>
  </div>
  
  <p>Date: ${new Date().toLocaleDateString()}</p>
  
  <p>Dear {{CANDIDATE_NAME}},</p>
  
  <p>We are pleased to offer you the position of <strong>{{JOB_TITLE}}</strong> in the {{DEPARTMENT}} department at {{COMPANY_NAME}}.</p>
  
  <h3>Position Details:</h3>
  <ul>
    <li><strong>Job Title:</strong> {{JOB_TITLE}}</li>
    <li><strong>Department:</strong> {{DEPARTMENT}}</li>
    <li><strong>Work Location:</strong> {{WORK_LOCATION}}</li>
  </ul>
  
  <h3>Compensation:</h3>
  <p>Your annual compensation will be <strong>{{SALARY}}</strong>.</p>
  
  <h3>Start Date:</h3>
  <p>Your expected joining date is <strong>{{JOINING_DATE}}</strong>.</p>
  
  <h3>Offer Validity:</h3>
  <p>This offer is valid until <strong>{{OFFER_EXPIRY_DATE}}</strong>. Please confirm your acceptance by this date.</p>
  
  <p>We look forward to welcoming you to our team!</p>
  
  <p>Sincerely,<br>
  HR Department<br>
  {{COMPANY_NAME}}</p>
</div>
`;


export const panelColumns = [
  {
    id: 1,
    panelName: "John Doe",
    skills: "React.js",
    availability: 2,
    totalExprience: "4",
  },
  {
    id: 2,
    panelName: "Jane Smith",
    skills: "Node.js",
    availability: 2,
    totalExprience: "4",
  },
  {
    id: 3,
    panelName: "Alice Johnson",
    skills: "Java",
    availability: 2,
    totalExprience: "4",
  },
];

export const allSkills = [
  "Python", "Amazon DynamoDB", "GraphQL", "RESTful Architecture",
  "Amazon Web Services", "GitHub", "Serverless Computing",
  "Node.js", "Electron", "React", "Vue.js", "Cloud Architecture",
  "AWS CloudFormation", "Microsoft Azure", "TypeScript", "Docker",
  "Kubernetes", "CI/CD", "Jenkins", "Terraform"
];
export const timeSlots = [
  { label: "10:00 AM - 12:00 PM", value: "10am-12pm" },
  { label: "12:00 PM - 2:00 PM", value: "12pm-2pm" },
  { label: "2:00 PM - 4:00 PM", value: "2pm-4pm" },
  { label: "4:00 PM - 6:00 PM", value: "4pm-6pm" },
];
export const totalExperienceOptions = [
  { value: "0-1", label: "0-1 years" },
  { value: "1-3", label: "1-3 years" },
  { value: "3-5", label: "3-5 years" },
  { value: "5+", label: "5+ years" },
];
export const panelTabs = [
  { label: 'Panel Details', Icon: JobOpeningIcon },
]

export const location = ["Noida", "Gurgaon", "USA", "Bangloare"]
export const totalExperience = ["3", "5", "6", "7"]
export const noiticPeriod = ["1 month", "15 days", "Immediate Joiner"]
export const status = ["Hired", "Rejected", "Pending"]
export const applicationSource = ["Naukari", "shine", "linkedin"]
